import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, removeToken } from '@/utils/auth'
import { getUserInfo } from '@/api/user'
import store from './store'
const whiteList = [
  '/login', 
  '/365Login', 
  '/pptxFilePreview',
  '/certificatePreview',

  '/system/shareStudentHandbookDetail',
  '/certPreview',
  '/trainCenter/companyCourse',  // 企业课程
  '/companyTrainManage/examineManage', // 考核管理
  '/companyTrainManage/planManage', // 计划管理
  '/signManage/specialOperation', // 特种作业报名
  '/signManage/specialEquipment', // 特种设备报名
  '/signManage/specialChemistry', // 危化企业报名
  '/signManage/specialBusiness', // 负责人安全员报名
  '/signManage/specialSkill', // 技能提升去除，不要了
  '/signManage/signHistory', // 报名数据
  '/courseManage/curriculumList', // 课件管理
  '/companyTrainManage/departExamineManage', // 部门考核管理
  '/page/homeListForZcfg', // 政策法规
  '/userCenter/examineHistory', // 考核记录
  '/certWechatCreate', // 证书生成
  '/noticeList', //  公告列表
]

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  if (whiteList.indexOf(to.path) !== -1 && to.query.token) {
    removeToken()
  }

  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        try {
          // get user info
          const userInfo = await store.dispatch('user/getUserInfo')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', userInfo)
          // dynamically add accessible routeslog（
          console.log(accessRoutes, to, 'accessropue')
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          console.log(error, '出现异常', store.getters.roles)
          await store.dispatch('user/resetToken')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      if (to.path == '/login' || to.path == '/365Login' || to.path == '/noticeList' || to.path == '/certificatePreview' || to.path == '/pptxFilePreview') {
        next()
      } else if(to.path == '/system/shareStudentHandbookDetail') {
        if (!localStorage.getItem('userInfo')) {
          const data = { role: 1 }
          localStorage.setItem('userInfo', JSON.stringify(data))
          localStorage.setItem('access_token', 'xxx')
          await store.dispatch('user/setUserInfo', data)
          window.location.reload()
        }
        next()
      } else {
        if (to.query.token) {
          localStorage.setItem('access_token', to.query.token)
          const res = await getUserInfo()
          const data = res.data.data
          data.in365 = 1
          localStorage.setItem('userInfo', JSON.stringify(data))
          await store.dispatch('user/setUserInfo', data)
          // window.location.reload()
          if (to.path == '/certWechatCreate') {
            next()
          } else {
            next(`${to.path}`)
          }
        } else {
          next(`/login?redirect=${to.path}`)
        }
      }
      
      NProgress.done()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
